// extracted by mini-css-extract-plugin
module.exports = {"metadatas":"Metadatas-metadatas-2QeI7"};